import { useNavigate } from "react-router-dom-v5-compat";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripsAppPage, PageLoadingScreen } from "@tenant/ui";
import { usePackageReservationDetailPage } from "../hooks/usePackageReservationDetailPage";
import { PackageReservationDetails } from "./PackageReservationDetails";

export interface PackageReservationDetailPageProps {
  tripsRoute: string;
}

export const PackageReservationDetailPage = ({
  tripsRoute,
}: PackageReservationDetailPageProps) => {
  const navigate = useNavigate();
  const { t } = useI18nContext();
  const { isLoading, isError, itinerary } = usePackageReservationDetailPage();

  return (
    <TripsAppPage>
      {isLoading ? (
        <PageLoadingScreen isLoading text={t("fetchingTrips")} />
      ) : isError || !itinerary ? (
        <div>
          <button type="button" onClick={() => navigate(tripsRoute)}>
            {t("selfServe.backToTrips")}
          </button>
        </div>
      ) : (
        <PackageReservationDetails
          itinerary={itinerary}
          tripsRoute={tripsRoute}
        />
      )}
    </TripsAppPage>
  );
};
